import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Nav, NavDropdown, Navbar } from 'react-bootstrap';

import logo from '../../../assets/img/brandImage.png';
import exit from '../../../assets/img/exit.png';
import cIcon from '../../../assets/img/c.png';

import './styles/navbar.css';
import AddPatientModal from '../AddPatientModal';

// @ts-ignore
import BootstrapSelect from 'react-bootstrap-select-dropdown';
import { dropdownStyle } from '../../../auth';
import { useClinicianProfile, useMenuSettings } from '../../hooks';
import { useLogout } from '../../hooks/useLogout';
import AddPatientSetupModal from '../AddNewPatient/AddTenancyPatientModal';
import { Brand } from './components/Brand';

const NavbarComponent = (): JSX.Element => {
  const navigate = useNavigate();
  const {
    firstName,
    tenancies,
    selectedTenancy,
    tenancyOptions,
    updateTenancy,
  } = useClinicianProfile();
  const { showAddNewPatient } = useMenuSettings();

  const [showAddPatient, setShowAddPatient] = useState(false);

  const { logout } = useLogout();

  const addPatientModal = React.useMemo(() => {
    const supportsAddPatientSetup =
      selectedTenancy?.features &&
      selectedTenancy.features.addPatientSetup?.active;
    if (supportsAddPatientSetup) {
      return (
        // @ts-ignore
        <AddPatientSetupModal
          open={showAddNewPatient}
          onSetOpen={setShowAddPatient}
        />
      );
    }
    return (
      <div>
        <AddPatientModal
          toChild={showAddPatient}
          sendToParent={setShowAddPatient}
        />
      </div>
    );
  }, [selectedTenancy, showAddNewPatient]);

  const home = () => {
    navigate('/');
  };

  const myAccount = () => {
    navigate('/myaccount');
  };

  const goToActivityFunding = () => {
    navigate('/activityFunding');
  };

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div>
      <Navbar id="topNav" expand="md" fixed="top">
        <Container fluid>
          <Brand
            onClick={home}
            logoSrc={logo}
            logoAlt="AI2 Logo"
            showText={true}
            clickable={true}
          />

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse className="justify-content-end">
            <Nav>
              {tenancies?.length && (
                <Nav.Item>
                  <BootstrapSelect
                    className="nav-item nav-link tenancy-toggle"
                    style={dropdownStyle}
                    options={tenancyOptions}
                    placeholder={selectedTenancy?.tenancy_name}
                    onChange={updateTenancy}
                    showTick={true}
                  />
                </Nav.Item>
              )}

              {process.env.REACT_APP_PROD !== 'true' && (
                <Nav.Item>
                  <Nav.Link
                    className="nav-item nav-link"
                    onClick={goToActivityFunding}
                  >
                    Activity funding
                    <div className="active-link"></div>
                  </Nav.Link>
                </Nav.Item>
              )}
              <Nav.Item>
                <Nav.Link className="nav-item nav-link" onClick={goToDashboard}>
                  Patient search
                  <div className="active-link"></div>
                </Nav.Link>
              </Nav.Item>
              {showAddNewPatient ? (
                <Nav.Item>
                  <Nav.Link
                    className="nav-item nav-link"
                    onClick={() => setShowAddPatient(true)}
                    eventKey="link-1"
                  >
                    Add new patient
                  </Nav.Link>
                </Nav.Item>
              ) : null}

              <NavDropdown.Divider />

              <Nav.Item onClick={() => myAccount()}>
                <Nav.Link>
                  {firstName}
                  <img className="user-icon" alt="" src={cIcon} />
                </Nav.Link>
              </Nav.Item>

              <NavDropdown.Divider />

              <Nav.Item onClick={() => logout()}>
                <Nav.Link eventKey="link-4">
                  <img alt="" src={exit} />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {showAddPatient && addPatientModal}
    </div>
  );
};

function NavbarComponentBasic(): JSX.Element {
  const { logout } = useLogout();

  const home = () => {
    window.location.href = '/';
  };

  return (
    <div>
      <Navbar id="topNav" expand="md" fixed="top">
        <Container fluid>
          <Brand
            onClick={home}
            logoSrc={logo}
            logoAlt="AI2 Logo"
            showText={true}
          />

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse className="justify-content-end">
            <Nav>
              <NavDropdown.Divider />

              <Nav.Item onClick={() => logout()}>
                <Nav.Link eventKey="link-4">
                  <img alt="" src={exit} />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export { NavbarComponent, NavbarComponentBasic };
